window.header = () => {
  return {
    openNav: null,
    activeLvl: null,
    activeSubMenu: [],
    showMobileNav: false,
    previousLvl2: null,
    resetMenus() {
      this.activeSubMenu = [];
      this.activeLvl = null;
      this.previousLvl2 = null;
    },
    showSubMenu(id, level, last) {
      this.activeLvl = level;
      // this.$activeSubMenu = document.getElementById(id);

      if (this.previousLvl2) {
        const filtered = this.activeSubMenu.filter(item => item !== this.previousLvl2);
        this.activeSubMenu = filtered;
        this.previousLvl2 = null;
      }

      switch (level) {
        case 1:
          this.activeSubMenu = [id];
          break;
        case 2:
          this.previousLvl2 = id;
          this.activeSubMenu.push(id);
          break;
      }
    }
  };
};
